import React from 'react'
import ReactDOM from 'react-dom/client'
import * as ReactDOMLegacy from 'react-dom'
import * as ReactJsxRuntime from 'react/jsx-runtime'
import * as ReactJsxDevRuntime from 'react/jsx-dev-runtime'
import * as ReactRouterDom from 'react-router-dom'

window.__IS_HOST__ = true

// Helper to wrap ES modules for Module Federation v2 share scope
const createModuleShare = (mod) => {
  if (!mod) return mod
  const share = { ...mod }
  if (mod.default) {
    Object.assign(share, mod.default)
  } else {
    share.default = mod
  }
  return share
}

if (!globalThis.__mf_module_cache__) {
  globalThis.__mf_module_cache__ = { share: {}, remote: {} }
}
const mfCache = globalThis.__mf_module_cache__
if (!mfCache.share) {
  mfCache.share = {}
}

const reactShare = createModuleShare(React)
mfCache.share.react = reactShare
mfCache.share['default:react'] = reactShare
mfCache.share['default:react@18.2.0'] = reactShare
mfCache.share['default:react^18.2.0'] = reactShare

const reactDomShare = createModuleShare({ ...ReactDOMLegacy, ...ReactDOM })
mfCache.share['react-dom'] = reactDomShare
mfCache.share['default:react-dom'] = reactDomShare
mfCache.share['default:react-dom@18.2.0'] = reactDomShare
mfCache.share['default:react-dom^18.2.0'] = reactDomShare

const jsxRuntimeShare = createModuleShare(ReactJsxRuntime)
mfCache.share['react/jsx-runtime'] = jsxRuntimeShare
mfCache.share['default:react/jsx-runtime'] = jsxRuntimeShare
mfCache.share['default:react/jsx-runtime@18.2.0'] = jsxRuntimeShare

const jsxDevRuntimeShare = createModuleShare(ReactJsxDevRuntime)
mfCache.share['react/jsx-dev-runtime'] = jsxDevRuntimeShare
mfCache.share['default:react/jsx-dev-runtime'] = jsxDevRuntimeShare
mfCache.share['default:react/jsx-dev-runtime@18.2.0'] = jsxDevRuntimeShare

const reactRouterDomShare = createModuleShare(ReactRouterDom)
mfCache.share['react-router-dom'] = reactRouterDomShare
mfCache.share['default:react-router-dom'] = reactRouterDomShare
mfCache.share['default:react-router-dom@6.3.0'] = reactRouterDomShare

if (!globalThis.__FEDERATION__) {
  globalThis.__FEDERATION__ = {}
}
const fedShare = globalThis.__FEDERATION__
if (!fedShare.__SHARE__) {
  fedShare.__SHARE__ = {}
}
if (!fedShare.__SHARE__.default) {
  fedShare.__SHARE__.default = {}
}

fedShare.__SHARE__.default.react = {
  '18.2.0': {
    get: () => Promise.resolve(() => reactShare),
    lib: reactShare,
    loaded: true,
    shareConfig: { singleton: true, requiredVersion: '^18.2.0' },
  },
}
fedShare.__SHARE__.default['react-dom'] = {
  '18.2.0': {
    get: () => Promise.resolve(() => reactDomShare),
    lib: reactDomShare,
    loaded: true,
    shareConfig: { singleton: true, requiredVersion: '^18.2.0' },
  },
}

import('./bootstrap')
